export default {
    modalBody: {
        padding: "0px 20px 25px 40px"
    },

    popUpStyle: {
        maxWidth: "unset"
    },

    okButton: {
        padding: "6px 30px",
        marginTop: "30px"
    },

    header: {
        marginBottom: "40px"
    }
}